import {CommonModule} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {TranslateModule} from '@ngx-translate/core';

import {FormFieldModule} from '@app/presentation/components/form-field/form-field.module';
import {RadioButtonModule} from '@app/presentation/components/radio-button/radio-button.module';
import {ButtonModule} from '@app/presentation/components/button/button.module';
import {AppBarModule} from '@app/presentation/components/app-bar/app-bar.module';

@Component({
  standalone: true,
  templateUrl: './add-to-cart-bottom-sheet.component.html',
  styleUrls: ['./add-to-cart-bottom-sheet.component.scss'],
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormFieldModule,
    RadioButtonModule,
    AppBarModule
  ],
})
export class AddToCartBottomSheetComponent implements OnInit {

  quantityControl = new UntypedFormControl(null)

  quantityFormGroup = new UntypedFormGroup({
    quantity: this.quantityControl
  })

  constructor(
    private bottomSheetRef: MatBottomSheetRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { initialValue: number }
  ) { }

  ngOnInit() {
    if (this.data && this.data.initialValue) {
      this.quantityControl.setValue(this.data.initialValue);
    }
  }

  closeBottomSheetWithoutSendData() {
    this.bottomSheetRef.dismiss();
  }

  closeBottomSheet() {
    this.bottomSheetRef.dismiss(this.quantityControl.value);
  }

}
